import api from '../services/api';

export const purchaseOrdersAPI = {
  getAll: (params) => api.get('/purchase-orders', { params }),
  getById: (id) => api.get(`/purchase-orders/${id}`),
  create: (data) => api.post('/purchase-orders', data),
  update: (id, data) => api.put(`/purchase-orders/${id}`, data),
  delete: (id) => api.delete(`/purchase-orders/${id}`),
  updateStatus: (id, statusOrPayload) => {
    const status = typeof statusOrPayload === 'string'
      ? statusOrPayload
      : statusOrPayload?.status;
    return api.patch(`/purchase-orders/${id}/status`, { status });
  },
  receive: (id, data) => api.post(`/purchase-orders/${id}/receive`, data),
  getReceivingHistory: (id) => api.get(`/purchase-orders/${id}/receiving-history`),
};

export default purchaseOrdersAPI;
